<template>
  <section class="retailers-page">
    <div class="bb-container">
      <!-- <div class="back">
        <div class="back__back">
          <a @click.prevent="$router.back()">
            <div class="back__name">
              <img
                src="../../assets/img/ico/ico-arrow-back.svg"
                loading="lazy"
                :alt="$t('generic.goback')"
                class="back__arrow"
              />
            </div>
          </a>
        </div>
      </div> -->

      <div class="retailers-content">
        <div class="retailers-page__header">
          <h1 class="retailers-page__title"> {{ $t("deals.title") }}</h1>
        </div>

        <!-- Cercador -->
        <div class="retailers-page__search">
          <div class="search-wrapper">
            <input 
              v-model="searchQuery"
              type="text"
              :placeholder="$t('deals.searcher.placeholder')"
              class="search-input"
            />
            <span class="search-icon"></span>
          </div>
        </div>

        <!-- Grid de retailers -->
        <div v-if="filteredRetailers.length > 0" class="retailers-grid">
          <div 
            v-for="retailer in filteredRetailers"
            :key="retailer.name"
            @click="goToRetailerPromotions(retailer.code)"
            class="retailer-card"
          >
            <div class="retailer-card__logo">
              <img 
                v-if="retailer.logo"
                :src="'https://images.hellobb.net/logos/' + retailer.logo" 
                :alt="retailer.displayName"
                @error="handleImageError($event, retailer)"
              />
              <div v-else class="retailer-card__logo-placeholder">
                {{ retailer.displayName.substring(0, 2).toUpperCase() }}
              </div>
            </div>
            <div class="retailer-card__info">
              <h3 class="retailer-card__name">{{ retailer.displayName }}</h3>
              <p class="retailer-card__count">
                {{ retailer.count }} {{ retailer.count === 1 ? $t("deals.availableOffer") : $t("deals.availableOffers") }}
              </p>
            </div>
          </div>
        </div>

        <!-- Estat buit -->
        <div v-else-if="!loading" class="retailers-page__empty">
          <div class="empty-state">
            <span class="empty-state__icon">{{ searchQuery ? '🔍' : '🎁' }}</span>
            <h2 class="empty-state__title">
              {{ searchQuery 
                ? ($t("deals.searcher.noResults") || "No se encontraron tiendas") 
                : ($t("deals.noPromotions") || "No hay promociones activas") 
              }}
            </h2>
            <p class="empty-state__text">
              {{ searchQuery
                ? ($t("deals.searcher.tryDifferentSearch") || "Intenta buscar con otras palabras")
                : ($t("deals.noPromotionsText") || "Cuando haya ofertas disponibles, las verás aquí.")
              }}
            </p>
          </div>
        </div>

        <!-- Loading state -->
        <div v-if="loading" class="retailers-page__loading">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PromotionsRetailersPage",
  data() {
    return {
      promotions: [],
      searchQuery: '',
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      userMarket: "loggedInUserMarket",
    }),
    
    retailers() {
      // Agrupar promocions per retailer
      const grouped = this.promotions.reduce((acc, promo) => {
        const name = promo.retailerName;
        if (!acc[name]) {
          acc[name] = {
            name: name,
            displayName: this.formatRetailerName(name),
            code: promo.retailerCode,
            logo: promo.retailerLogo || null,
            count: 0,
          };
        }
        acc[name].count++;
        return acc;
      }, {});
      
      // Convertir a array i ordenar per número de promos (descendent)
      return Object.values(grouped).sort((a, b) => b.count - a.count);
    },
    
    filteredRetailers() {
      if (!this.searchQuery) return this.retailers;
      
      const query = this.searchQuery.toLowerCase();
      return this.retailers.filter(retailer => {
        return retailer.displayName.toLowerCase().includes(query) ||
               retailer.name.toLowerCase().includes(query);
      });
    },
  },
  methods: {
    formatRetailerName(name) {
      const retailers = {
        'elcorteingles': 'El Corte Inglés',
        'momcozy': 'Momcozy',
        'amazon': 'Amazon',
        'amazontest': 'Amazon Test',
        'decathlon': 'Decathlon',
        'vertbaudet': 'Vertbaudet',
        'bebitus': 'Bebitus',
      };
      return retailers[name] || this.$utils?.capitalize(name) || name;
    },
    
    handleImageError(event, retailer) {
      // Si el logo falla, mostrar inicials
      event.target.style.display = 'none';
      const logoDiv = event.target.parentElement;
      logoDiv.innerHTML = `<div class="retailer-card__logo-placeholder">${retailer.displayName.substring(0, 2).toUpperCase()}</div>`;
    },
    
    goToRetailerPromotions(retailerCode) {
      this.$router.push({
        name: 'active-deals-retailer',
        params: { retailer: retailerCode }
      });
    },
    
    async loadPromotions() {
      this.loading = true;
      
      try {
        const response = await this.$store.dispatch('getAllPromotions', {
          market: this.userMarket || 'ES',
        });
        
        this.promotions = Array.isArray(response) ? response : [];
      } catch (error) {
        console.error('Error carregant promocions:', error);
        this.promotions = [];
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.loadPromotions();
  },
};
</script>

<style scoped>
.retailers-page {
  padding: 24px 0;
  min-height: 60vh;
}

.retailers-content {
  max-width: 800px;
  margin: 0 auto;
}

.retailers-page__header {
  margin-bottom: 24px;
}

.retailers-page__title {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.retailers-page__search {
  margin-bottom: 32px;
}

.search-wrapper {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 12px 48px 12px 16px;
  font-size: 16px;
  border: 1px solid #e4e4e4;
  border-radius: 50px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-color: #d7d7d7;
  color: #262626;
}

.search-input:focus {
  outline: none;
  border: 2px solid #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
  padding: 12px 48px 12px 15px;
}

.search-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-image: url(../../assets/img/ico/ico-search.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  opacity: 0.5;
}

.retailers-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.retailer-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 200px;
}

.retailer-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
  border-color: #f97316;
}

.retailer-card:active {
  transform: translateY(0);
}

.retailer-card__logo {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  overflow: hidden;
}

.retailer-card__logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

.retailer-card__logo-placeholder {
  font-size: 28px;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
}

.retailer-card__info {
  width: 100%;
}

.retailer-card__name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.retailer-card__count {
  font-size: 14px;
  color: #f97316;
  margin: 0;
  font-weight: 600;
}

.retailers-page__empty {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.empty-state {
  text-align: center;
  max-width: 400px;
}

.empty-state__icon {
  font-size: 64px;
  display: block;
  margin-bottom: 16px;
}

.empty-state__title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;
}

.empty-state__text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.retailers-page__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 767px) {
  .retailers-page__title {
    font-size: 24px;
  }
  
  .search-input {
    font-size: 14px;
  }
  
  .retailers-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .retailer-card {
    padding: 20px 16px;
    min-height: 180px;
  }
  
  .retailer-card__logo {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
    padding: 16px;
  }
  
  .retailer-card__name {
    font-size: 16px;
  }
  
  .retailer-card__count {
    font-size: 13px;
  }
  
  .retailer-card__logo-placeholder {
    font-size: 22px;
  }
}
</style>
